import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { getEnvironment } from "./utils/environment";
import { reportClientError } from "./utils/reportClientError";
import { isValidClientEventCode } from "./types/clientEventCode";
import "./global.css";

window.addEventListener("unhandledrejection", (ev) => {
  // Errors with a valid event code are intentional and already tracked at the throw site
  if (ev.reason instanceof Error && isValidClientEventCode(ev.reason.name)) return;
  reportClientError(ev.reason, "UNHANDLED_REJECTION");
});

async function enableMocking(): Promise<void> {
  const { internal } = getEnvironment();

  if (!internal) return;
  if (localStorage.getItem("psmConfigEnableMSW") !== "true") return;

  try {
    const { worker } = await import("./mocks/msw/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  } catch (error) {
    console.warn("[MSW] Failed to start service worker", error);
  }
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!, {
    onCaughtError: (error) => reportClientError(error, "REACT_RENDER_ERROR"),
    onUncaughtError: (error) => reportClientError(error, "REACT_RENDER_ERROR"),
  }).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
